import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Doughnut, Bar } from "react-chartjs-2"
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  BarElement,
} from "chart.js"
import "../styles/AdminCharts.css"
import { fetchLeads } from "../../store/lead"

// Register components for Chart.js
ChartJS.register(
  CategoryScale,
  LinearScale,
  ArcElement,
  BarElement,
  Title,
  Tooltip,
  Legend
)

const initialChartData = {
  labels: [],
  datasets: [
    {
      label: "",
      data: [],
      backgroundColor: [],
      borderColor: [],
      borderWidth: 1,
    },
  ],
}

const AdminLeadsChart = () => {
  const dispatch = useDispatch()
  const leads = useSelector((state) => state.lead.leads)
  const [cityChartData, setCityChartData] = useState(initialChartData)
  const [serviceChartData, setServiceChartData] = useState(initialChartData)
  const [contractJobChartData, setContractJobChartData] =
    useState(initialChartData)

  useEffect(() => {
    dispatch(fetchLeads())
  }, [dispatch])

  useEffect(() => {
    if (leads.length) {
      const cityData = {}
      const serviceData = {}
      let contractSignedCount = 0
      let jobCompletedCount = 0

      leads.forEach((lead) => {
        cityData[lead.city] = (cityData[lead.city] || 0) + 1
        serviceData[lead.service] = (serviceData[lead.service] || 0) + 1
        if (lead.contractSigned) contractSignedCount++
        if (lead.jobCompleted) jobCompletedCount++
      })

      setCityChartData({
        labels: Object.keys(cityData),
        datasets: [
          {
            label: "Leads by City",
            data: Object.values(cityData),
            backgroundColor: generateColorArray(Object.keys(cityData), 0.5),
            borderColor: generateColorArray(Object.keys(cityData), 1),
          },
        ],
      })

      setServiceChartData({
        labels: Object.keys(serviceData),
        datasets: [
          {
            label: "Leads by Service",
            data: Object.values(serviceData),
            backgroundColor: generateColorArray(Object.keys(serviceData), 0.5),
            borderColor: generateColorArray(Object.keys(serviceData), 1),
          },
        ],
      })

      setContractJobChartData({
        labels: ["Contract Signed", "Job Completed"],
        datasets: [
          {
            label: "Count",
            data: [contractSignedCount, jobCompletedCount],
            backgroundColor: [
              "rgba(255, 99, 132, 0.5)",
              "rgba(54, 162, 235, 0.5)",
            ],
            borderColor: ["rgba(255, 99, 132, 1)", "rgba(54, 162, 235, 1)"],
          },
        ],
      })
    }
  }, [leads])

  const generateColorArray = (keys, opacity) => {
    const baseColors = [
      [76, 175, 80],
      [178, 178, 178],
      [255, 99, 132],
      [54, 162, 235],
      [255, 159, 64],
      [201, 203, 207],
      [153, 102, 255],
    ]
    return keys.map((_, index) => {
      const color = baseColors[index % baseColors.length]
      return `rgba(${color.join(", ")}, ${opacity})`
    })
  }

  return (
    <div className="myChart-container">
      <div className="chart-container">
        <h3>City Distribution</h3>
        <Bar
          data={cityChartData}
          className="barChart-canvas"
          options={{ indexAxis: "y" }}
        />
      </div>
      <div className="chart-container">
        <h3>Service Distribution</h3>
        <Doughnut data={serviceChartData} className="myChart-canvas" />
      </div>
      <div className="chart-container">
        <h3>Contracts Signed vs Jobs Completed</h3>
        <Bar data={contractJobChartData} className="barChart-canvas" />
      </div>
    </div>
  )
}

export default AdminLeadsChart
